(function () {
    'use strict';
    angular.module('app').directive('selectioncommandnewdoc', selectioncommand_newdoc);
    function selectioncommand_newdoc() { 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                newDocDialogShown: '=?'
            },
            controller: 'newdoc',
            templateUrl: 'app/selectioncommand/selectioncommand_newdoc.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();